import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ShortcutHelpOverlay = ({ open, onClose }) => {
  const theme = useTheme();

  const shortcuts = [
    { action: "Navigate Home", keys: "G then H" },
    { action: "Navigate Dashboard", keys: "G then D" },
    { action: "Navigate Product", keys: "G then N" },
    { action: "Navigate Receipt", keys: "G then R" },
    { action: "Navigate Payment", keys: "G then P" },
    { action: "Navigate W.Transfer", keys: "G then W" },
    { action: "New Sale B2B", keys: "Alt + Shift + N" },
    { action: "New Sale B2C", keys: "Alt + Shift + C" },
    { action: "Toggle Help Overlay", keys: "?" },
    { action: "Open Item History", keys: "Alt + H" },
    { action: "Open Item Stock Details", keys: "Alt + P" },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-modal="true"
      role="dialog"
      aria-labelledby="shortcut-dialog-title"
    >
      <DialogTitle
        id="shortcut-dialog-title"
        sx={{ bgcolor: theme.palette.primary.main, color: "white" }}
      >
        Keyboard Shortcuts
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Press <strong>G</strong> followed by a key (within 1.2s) to navigate.
          Shortcuts are disabled while typing in text fields.
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small" aria-label="shortcuts table">
            <TableHead>
              <TableRow sx={{ bgcolor: theme.palette.grey[100] }}>
                <TableCell>
                  <strong>Action</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Shortcut</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shortcuts.map((row) => (
                <TableRow key={row.action}>
                  <TableCell component="th" scope="row">
                    {row.action}
                  </TableCell>
                  <TableCell align="right">
                    <Box
                      component="span"
                      sx={{
                        bgcolor: theme.palette.grey[200],
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontFamily: "monospace",
                        fontWeight: "bold",
                      }}
                    >
                      {row.keys}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close (Esc)
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShortcutHelpOverlay;
